import type { LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

type EmptyStateProps = {
  icon: LucideIcon;
  title: string;
  body: string;
  actionLabel?: string;
  to?: string;
};

export const EmptyState = ({ icon: Icon, title, body, actionLabel, to }: EmptyStateProps) => (
  <div className="flex flex-col items-center px-5 py-8 text-center">
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-50">
      <Icon className="h-8 w-8 text-blue-600" strokeWidth={2} />
    </div>
    <h3 className="mt-4 text-h3 text-neutral-900">{title}</h3>
    <p className="mt-2 max-w-[280px] text-body-sm text-neutral-500">{body}</p>
    {actionLabel && to ? (
      <Button asChild size="sm" className="mt-5">
        <Link to={to}>{actionLabel}</Link>
      </Button>
    ) : null}
  </div>
);
